import { SET_SAGA_REQUEST_ERRORS } from './actions';
var initialErrorsState = null;
export var sagaRequestErrorsReducer = function (state, action) {
    if (state === void 0) { state = initialErrorsState; }
    if (action.type === SET_SAGA_REQUEST_ERRORS) {
        return action.payload;
    }
    return state;
};
